export const UPDATE_LOADING_BRANCHEN = 'UPDATE_LOADING_BRANCHEN';
export const UPDATE_ERROR_BRANCHEN = 'UPDATE_ERROR_BRANCHEN';
export const UPDATE_BRANCHEN = 'UPDATE_BRANCHEN';